export const initialState = {
  currentPage: null,
  prevPage: null,
  nextPage: null,
  currentPageNum: 1,
  isLoading: true,
  pageLoading: false,
  data: [],
  selectedRow: null,
  advancedSearch: false,
  editRow: false,
  docsModal: false,
  advancedSearch: false,
};

export const reducerFunction = (state, action) => {
  switch (action.type) {
    case "SET_CURRENT_PAGE":
      return {
        ...state,
        currentPage: action.page,
        currentPageNum: action.pageNum,
      };
    case "FETCH_DATA":
      return {
        ...state,
        isLoading: true,
        data: [],
      };
    case "STORE_DATA":
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        nextPage: action.next,
        prevPage: action.previous,
      };
    case "SET_SELECTED_ROW":
      return {
        ...state,
        selectedRow: action.selectedRow,
      };
    case "CLOSE_SELECTED_ROW":
      return {
        ...state,
        selectedRow: null,
      };
    case "EDIT_ROW":
      return {
        ...state,
        editRow: true,
      };
    case "CLOSE_EDIT_ROW":
      return {
        ...state,
        editRow: false,
      };
    case "OPEN_DOCS":
      return {
        ...state,
        docsModal: true,
      };
    case "CLOSE_DOCS":
      return {
        ...state,
        docsModal: false,
      };
    case "LOAD_PAGE":
        return {
            ...state,
            pageLoading: action.payload
        }

    default:
      return state;
  }
};
